"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.reset.button': '重置训练器',
};
